// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2b7rE","content":"styles_content__3i3V8","checkbox":"styles_checkbox__3TUDo","checkboxLabel":"styles_checkboxLabel__2Ea_D"};